import { ReactNode } from 'react'

export type CallDataExtractionLayoutShadcnComponentProps = {
  children: ReactNode
}

export function CallDataExtractionLayoutShadcnComponent({ children }: CallDataExtractionLayoutShadcnComponentProps) {
  return <>{children}</>
}
